import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

var router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes: [{
            path: '/',
            component: () => import('./pages/home'),
            meta: {
                title: '首页'
            }
        },
        {
            path: '/about',
            component: () => import('./pages/about'),
            meta: {
                title: '关于我们'
            }
        },
        {
            path: '/news/:tag',
            component: () => import('./pages/news'),
            meta: {
                title: '新闻动态',
                keepAlive: true
            }
        },
        {
            path: '/new/detail',
            component: () => import('./pages/news/newsdetail.vue'),
            meta: {
                title: '新闻动态详情',
                keepAlive: true
            }
        },
        {
            path: '/product',
            component: () => import('./pages/product'),
            meta: {
                title: '产品系列'
            }
        },
        {
            path: '/join',
            component: () => import('./pages/agent'),
            meta: {
                title: '代理加盟'
            }
        },
        {
            path: '/talnet',
            component: () => import('./pages/talent'),
            meta: {
                title: '招贤纳士'
            }
        },
        {
            path: '/amap',
            component: () => import('./pages/map/amap'),
            meta: {
                title: '联系方式'
            }
        },
        {
            path: '/enter',
            component: () => import('./pages/enter/enters'),
            meta: {
                title: '商家入驻'
            }
        },
        {
            path: '/staff/login',
            component: () => import('./pages/staff/login'),
            meta: {
                title: '员工登录'
            }
        },
        {
            path: '/staff/pandect',
            component: () => import('./pages/staff/pandect'),
            meta: {
                title: '员工分红'
            }
        },
        {
            path: '/im/pc',
            component: () => import('./pages/im/pcpage'),
            meta: {
                title: '销巴IM即时通讯工具'
            },
        },
        {
            path: '/im/mobile',
            component: () => import('./pages/im/immobile'),
            meta: {
                title: '销巴IM即时通讯工具'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    let title = to.meta && to.meta.title;
    if (title) {
        document.title = title + ' - 销巴生活';
    }else{
        document.title = '销巴生活'
    }
    if (to.path === "/im/pc" || to.path === "/im/mobile") {
        // const bg_color = document.getElementsByClassName("bg-color");
        // bg_color.length && (bg_color[0].style.display = "none");
        const other = document.getElementById("cert_show_img");
        other && (other.parentElement.parentElement.style.display = "none");
    }
    next();
})

export default router